import { ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import { TitleCasePipe } from '@angular/common';

// Material
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';



// rxjs
import { BehaviorSubject } from 'rxjs';

import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { CUSTOM_DATE_FORMATS } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-formats';
import { SchedulingComponent } from '../../scheduling.component';
import { SchedulingPlateFoundEditDialog } from '../plate-found-edit/scheduling-plate-found-edit.dialog';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIBlockedAttentionSchedules } from 'src/services/api-services/api-blocked-attention-schedule';
import { APIDealerBlockedServices } from 'src/services/api-services/api-dealer-blocked-services';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { CustomerBasicData } from '../../../../services/api-services/api-interfaces/customerBasicData.interface';
import { HelperService } from 'src/services/helperService';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-search-plate',
    templateUrl: './search-plate.dialog.html',
    styleUrls: ['./search-plate.dialog.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        TitleCasePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})

export class SearchPlateDialog implements OnInit {
  

  appointmentSchedule = '';
  plateNumberSearch: string = "";
  isError$ = new BehaviorSubject<boolean>(false);
  isLoading$ = new BehaviorSubject<boolean>(false);
  currentUserRoleId = Number(this.helperService.user.role.roleId); 
  modelVehicle:any[]=[]
  constructor(
    public dialogRef: MatDialogRef<SchedulingComponent>,
    public dialog: MatDialog,
    public ScheduleService: APIServiceSchedule,
    @Inject(MAT_DIALOG_DATA) public appointment: any,
   
    public titleCasePipe: TitleCasePipe,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public blockedAttentionScheduleService: APIBlockedAttentionSchedules,
    public dealerBlockedService: APIDealerBlockedServices,
    public vehicleDataService: VehicleDataService,
    public customerBasicDataService: APICustomerBasicDataService,
    public helperService: HelperService,
    private translate: TranslateService,
  ){
    // console.log(this.appointment)
    if (this.helperService.user.advisorId) {
      this.appointmentSchedule = this.titleCasePipe.transform(`${new Date(this.appointment.start).toLocaleDateString(this.helperService.user.language, { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true })}`);    
    } else {
      this.appointmentSchedule = this.titleCasePipe.transform(`${new Date(this.appointment.start).toLocaleDateString(this.helperService.user.language, { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true })}`);    
    }
  }

  ngOnInit(): void {
  }

  openDialogEditData(  customerData): void {

    // // Contact Center
    // if(this.currentUserRoleId === 3 || this.currentUserRoleId === 4){
    //   this.dialog.open(SchedulingPlateFoundEditDialog, {
    //     width: '903px',
    //     data: {   
    //       advisor: this.appointment.advisor,
    //       brand: this.appointment.brand,
    //       city: this.appointment.city,
    //       end: this.appointment.end,
    //       start: this.appointment.start,
    //       typeOfService: this.appointment.typeOfService,
    //       workshop: this.appointment.workshop,
    //       address: customerData.address,
    //       customerId: customerData.customerId,
    //       documentTypeId: customerData.documentType,
    //       email: customerData.email,
    //       firstName: customerData.firstName,
    //       identification: customerData.identification,
    //       lastName: customerData.lastName,
    //       phone: customerData.phone,
    //       relationshipVehicleId: customerData.relationshipVehicleId,
    //       sapCustomerId: customerData.sapCustomerId,
    //       mileage: vehicleData.mileage,
    //       plate: vehicleData.plate,
    //       vehicleId: vehicleData.vehicleId,
    //       vin: vehicleData.vin
    //     }
    //   });
    // }

    // // Workshop
    // if(this.currentUserRoleId === 2 || this.currentUserRoleId === 6){
    //   this.dialog.open(SchedulingPlateFoundEditDialog, {
    //     width: '903px',
    //     data: {   
    //       advisor: this.appointment.advisor,
    //       typeOfService: this.appointment.typeOfService,
    //       brand: this.appointment.brand,
    //       end: this.appointment.end,
    //       start: this.appointment.start,
    //       address: customerData.address,
    //       customerId: customerData.customerId,
    //       documentTypeId: customerData.documentType,
    //       email: customerData.email,
    //       firstName: customerData.firstName,
    //       identification: customerData.identification,
    //       lastName: customerData.lastName,
    //       phone: customerData.phone,
    //       relationshipVehicleId: customerData.relationshipVehicleId,
    //       sapCustomerId: customerData.sapCustomerId,
    //       mileage: vehicleData.mileage,
    //       plate: vehicleData.plate,
    //       vehicleId: vehicleData.vehicleId,
    //       vin: vehicleData.vin,
    //       blockedServices: this.appointment.blockedServices,
    //       city: this.appointment.city,
    //       workshop: this.helperService.user.workshopId,
    //       workshopBlockedServices: this.appointment.workshopBlockedServices
    //     }
    //   });
    // }

    // //  Service Advisor
    //  if(this.currentUserRoleId === 1){
    //   this.dialog.open(SchedulingPlateFoundEditDialog, {
    //     width: '903px',
    //     data: {   
    //       advisor: this.helperService.user.advisorId,
    //       WorkshopId: this.helperService.user.workshopId,
    //       typeOfService: this.appointment.typesOfService,
    //       end: this.appointment.end,
    //       start: this.appointment.start,
    //       address: customerData.address,
    //       customerId: customerData.customerId,
    //       documentTypeId: customerData.documentType,
    //       email: customerData.email,
    //       firstName: customerData.firstName,
    //       identification: customerData.identification,
    //       lastName: customerData.lastName,
    //       phone: customerData.phone,
    //       relationshipVehicleId: customerData.relationshipVehicleId,
    //       sapCustomerId: customerData.sapCustomerId,
    //       mileage: vehicleData.mileage,
    //       plate: vehicleData.plate,
    //       vehicleId: vehicleData.vehicleId,
    //       vin: vehicleData.vin
    //     }
    //   });
    // }

    
      this.dialog.open(SchedulingPlateFoundEditDialog, {
        width: '903px',
        data: {
          advisor: this.currentUserRoleId === 1 ? this.helperService.user.advisorId : this.appointment.advisor,
          brand: this.appointment.brand,
          city: this.currentUserRoleId === 3 || this.currentUserRoleId === 4 ? this.appointment.city : undefined,
          end: this.appointment.end,
          start: this.appointment.start,
          typeOfService: this.currentUserRoleId === 1 ? this.appointment.typesOfService : this.appointment.typeOfService,
          workshop: this.currentUserRoleId === 1 ? this.helperService.user.workshopId : this.currentUserRoleId === 2 || this.currentUserRoleId === 6 ? this.helperService.user.workshopId : this.appointment.workshop,
          customerPersonType:customerData.personType,
          customerPersonTypeId:customerData.personTypeId,
          customerDocType:customerData.typeName,
          address: customerData.address,
          customerId: customerData.customerId,
          documentTypeId: customerData.typeId,
          email: customerData.email,
          firstName: customerData.firstName,
          identification: customerData.identification,
          lastName: customerData.lastName,
          phone: customerData.phone,
          relationshipVehicleId: customerData.relationshipVehicleId,
          sapCustomerId: customerData.sapCustomerId,
          mileage: customerData.mileage,
          plate: customerData.plate,
          vehicleId: customerData.vehicleId,
          vin: customerData.vin,
          modelDescription:customerData.vehicleModelInfo.modelDescription,
          modelYear:customerData.vehicleModelInfo.modelYear,
          modelVehicle:customerData.vehicleModelInfo.models,
          // Campos adicionales específicos para algunos roles
          blockedServices: this.currentUserRoleId === 2 || this.currentUserRoleId === 6 ? this.appointment.blockedServices : undefined,
          workshopBlockedServices: this.currentUserRoleId === 2 || this.currentUserRoleId === 6 ? this.appointment.workshopBlockedServices : undefined
        }
      });
    
    
  }
  toUpperPlateNumber(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }
  
  onPlateNumberSearchClick(appointmentSchedule?) {

     if(this.helperService.user.role.roleId != 1){
    this.isLoading$.next(true);
    this.vehicleDataService?.getValidatedDataWithCountryAndbrand(this.plateNumberSearch.toUpperCase(),this.appointment.brand.brandId)
      .subscribe(customer => {
        if(customer.customerId === 0) {
          this.isError$.next(true);
          this.isLoading$.next(false);
        }
        else{
          this.isError$.next(false);
         
              this.dialog.closeAll()
              
              this.openDialogEditData(customer);
         
        }
        error: (error) => {

          if(error.status === 401){
            this.helperService.logoutToken()
          }
          else {
          const translateTxtNotMatch = this.translate.instant("notMatchFound") 
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =translateTxtNotMatch 
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)}
        }
    })
  }
  else {
     this.isLoading$.next(true);
    this.vehicleDataService?.getValidatedDataWithCountryAndbrand(this.plateNumberSearch.toUpperCase(),1)
      .subscribe(customer => {
        if(customer.customerId === 0) {
          this.isError$.next(true);
          this.isLoading$.next(false);
        }
        else{
          this.isError$.next(false);
         
              this.dialog.closeAll()
              customer.vehicleModelInfo.models = ["Otros"]
              this.openDialogEditData(customer);
         
        }
        error: (error) => {

          if(error.status === 401){
            this.helperService.logoutToken()
          }
          else {
          const translateTxtNotMatch = this.translate.instant("notMatchFound") 
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =translateTxtNotMatch 
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)}
        }
    })
  }
  }
serchModels(){
   this.isLoading$.next(true);
    if(this.helperService.user.role.roleId != 1){
    this.vehicleDataService?.getValidatedDataWithCountryAndbrand(this.plateNumberSearch.toUpperCase(),this.appointment.brand.brandId)
      .subscribe(customer => {
    
          this.modelVehicle = customer.vehicleModelInfo.models
          
          this.isLoading$.next(false);
          this.onNewPlateNumberClick()
      
        error: (error) => {

          if(error.status === 401){
            this.helperService.logoutToken()
          }
          else {
          const translateTxtNotMatch = this.translate.instant("notMatchFound") 
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =translateTxtNotMatch 
          setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)}
        }
    })
}else {
   
          this.modelVehicle = ["Otros"]
          
          this.isLoading$.next(false);
          this.onNewPlateNumberClick()
      
        }
  
}
  onNewPlateNumberClick(data?) {
    
    this.dialog.closeAll()
    if(this.currentUserRoleId === 1){
      this.dialog.open(SchedulingPlateFoundEditDialog, {
      width: '903px',
      data: {
        advisorAttentionHours: this.appointment.advisorAttentionHoursDays,
        advisor: this.appointment.advisorSelected,
        blockedServices: this.appointment.blockedServices,
        brand: this.appointment.brandSelected,
        city: this.appointment.city,
        end: this.appointment.end,
        start: this.appointment.start,
        typeOfService: this.appointment.typeOfServiceSelected,
        workshop: this.helperService.user.workshopId,
        workshopBlockedServices: this.appointment.workshopBlockedServices,
        modelVehicle:this.modelVehicle

      }
      });
    }

    if(this.currentUserRoleId === 2 || this.currentUserRoleId === 6){
      this.dialog.open(SchedulingPlateFoundEditDialog, {
        width: '903px',
        data: {   
          advisor: this.appointment.advisor,
          brand: this.appointment.brand,
          city: this.appointment.city,
          end: this.appointment.end,
          start: this.appointment.start,
          typeOfService: this.appointment.typeOfService,
          workshop: this.helperService.user.workshopId,
           modelVehicle:this.modelVehicle
        }
      });
    }


    // Contact Center
    if(this.currentUserRoleId === 3 || this.currentUserRoleId === 4){
      this.dialog.open(SchedulingPlateFoundEditDialog, {
        width: '903px',
        data: {   
          advisor: this.appointment.advisor,
          brand: this.appointment.brand,
          city: this.appointment.city,
          end: this.appointment.end,
          start: this.appointment.start,
          typeOfService: this.appointment.typeOfService,
          workshop: this.appointment.workshop,
           modelVehicle:this.modelVehicle
        }
      });
    }


  }




}